import { React, useState, useEffect } from 'react';
import { CurrentPill } from '@constants/pursuitLeaderConstants';
import DropDownSelect from '@atoms/dropDownSelect/dropDownSelect';
import {
  DataContainer,
  DataNotAvailable,
  LabelContainer,
  MetricsContainer,
  SubHeaderContainer,
  TitleContainer,
  TitleDetails,
  ValueContainer,
  YearlyMetricsContainer,
} from '@atoms/dashboard/yearlyMetrics.styles';
import { useRecoilValue } from 'recoil';
import { Current_User, Recoil_Quarter_State, System_Date_Time_State } from '@recoil/recoil';
import { formatNumberWithKAndM, processNumber } from '@util/commonUtil';
import { getPlYearlyMetrics } from '@services/pursuitLeaderServices';
import { QUARTERLY_DETAILS } from '@constants/commonConstants';
import SpinnerLoader from '@atoms/SpinnerLoader';

const YearlyMetrics = () => {
  const [yearlyMatrix, setYearlyMatrices] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const [isLoading, setIsLoading] = useState(false);

  let currentYear;
  const yearOptionsList = [];

  if (quarterInfo !== null) {
    currentYear = quarterInfo.fiscal_year;

    for (let i = parseInt(currentYear, 10) - 4; i <= parseInt(currentYear, 10) + 1; i++) {
      if (i >= 2024 && i > parseInt(currentYear, 10) - 4) {
        yearOptionsList.push({ value: i.toString(), label: i.toString() });
      }
    }
  }

  useEffect(() => {
    if (quarterInfo !== null) {
      getYearLyMatrices(quarterInfo.fiscal_year);
    }
  }, [quarterInfo]);

  const getYearLyMatrices = async year => {
    setYearlyMatrices([]);
    const yearlyMetricsData = await getPlYearlyMetrics(
      year,
      currentUser.email,
      systemDateTime.split('T')[0],
    );
    setYearlyMatrices(yearlyMetricsData);
    setSelectedYear(year);
    setIsLoading(isLoading);
  };
  const onDropDownYearChanged = newlySelectedYear => {
    setSelectedYear(newlySelectedYear);
    getYearLyMatrices(newlySelectedYear);
  };

  const getAccuracyValue = accuracyValue => {
    if (accuracyValue !== null) return `${processNumber(accuracyValue)}%`;
    else if (selectedYear < quarterInfo.fiscal_year && accuracyValue === null) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else return QUARTERLY_DETAILS.TBD;
  };

  return (
    <>
      {quarterInfo !== null ? (
        <YearlyMetricsContainer>
          <SubHeaderContainer>
            <TitleDetails>
              <TitleContainer>
                Fiscal Year {selectedYear ? selectedYear : currentYear}
              </TitleContainer>

              {selectedYear === currentYear ? <CurrentPill /> : null}
            </TitleDetails>
            <DropDownSelect
              label="Fiscal Year"
              options={yearOptionsList}
              defaultValue={currentYear.toString()}
              onDropDownValueChanged={year => {
                onDropDownYearChanged(year);
                setIsLoading(!isLoading);
              }}
            />
          </SubHeaderContainer>
          {isLoading ? (
            <MetricsContainer style={{ position: 'relative', top: '50%', left: '50%' }}>
              <SpinnerLoader color="#155CB4" />
            </MetricsContainer>
          ) : (
            <>
              {!!yearlyMatrix && yearlyMatrix.length !== 0 ? (
                <MetricsContainer>
                  <DataContainer>
                    <ValueContainer>
                      {formatNumberWithKAndM(yearlyMatrix.sold_amount) || 0}
                    </ValueContainer>
                    <LabelContainer>Won Amount (Till Date)</LabelContainer>
                  </DataContainer>
                  <DataContainer>
                    <ValueContainer>
                      {formatNumberWithKAndM(yearlyMatrix.sold_opportunities) || 0}
                    </ValueContainer>
                    <LabelContainer>Won Opportunities (Till Date)</LabelContainer>{' '}
                  </DataContainer>
                  <DataContainer>
                    <ValueContainer>
                      {formatNumberWithKAndM(yearlyMatrix.forecasted) || 0}
                    </ValueContainer>
                    <LabelContainer>Forecasted (Till Date)</LabelContainer>{' '}
                  </DataContainer>
                  <DataContainer>
                    <ValueContainer>
                      {getAccuracyValue(yearlyMatrix.quarterly_forecast_accuracy)}
                    </ValueContainer>
                    <LabelContainer>Quarterly Forecast Accuracy (Till Date)</LabelContainer>{' '}
                  </DataContainer>
                  <DataContainer>
                    <ValueContainer>
                      {getAccuracyValue(yearlyMatrix.monthly_forecast_accuracy)}
                      {/* <SuccessImage src={successImage} alt="success" /> */}
                    </ValueContainer>
                    <LabelContainer>Monthly Forecast Accuracy (Till Date)</LabelContainer>{' '}
                  </DataContainer>
                </MetricsContainer>
              ) : null}
            </>
          )}
          <>
            {yearlyMatrix === undefined ? (
              <DataNotAvailable>Data Not Available ¯\_(ツ)_/¯</DataNotAvailable>
            ) : null}
          </>
        </YearlyMetricsContainer>
      ) : null}
    </>
  );
};

export default YearlyMetrics;
